import { StationModel } from '../../dictStore/dictStoreData';
import NsiStoreBase from '../nsiStoreBase';
import { NsiStationStoreService } from './nsiStationStore.service';

class NsiStationStore extends NsiStoreBase<StationModel, NsiStationStoreService> {
  service = new NsiStationStoreService();
}

export default new NsiStationStore();
